import { useState } from 'react';
import { Select } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useBanners, useAttachLinkToBanner } from '../../hooks/useBanners';
import { Button, Modal } from '@shared/ui';

interface AttachLinkToBannerModalProps {
    isOpen: boolean;
    onClose: () => void;
    link: string;
    onSuccess?: () => void;
}

export default function AttachLinkToBannerModal({
    isOpen,
    onClose,
    link,
    onSuccess,
}: AttachLinkToBannerModalProps) {
    const [selectedBannerId, setSelectedBannerId] = useState<string | null>(null);
    const { data: banners = [] } = useBanners(false, false);
    const attachLink = useAttachLinkToBanner();

    const handleAttachLink = async () => {
        if (!selectedBannerId || !link) {
            return;
        }

        try {
            const bannerId = parseInt(selectedBannerId, 10);
            await attachLink.mutateAsync({
                id: bannerId,
                data: { link },
            });

            notifications.show({
                title: 'Успешно',
                message: 'Ссылка успешно прикреплена к баннеру',
                color: 'green',
            });

            setSelectedBannerId(null);
            onClose();
            onSuccess?.();
        } catch (error) {
            console.error('Ошибка при прикреплении ссылки к баннеру:', error);
            notifications.show({
                title: 'Ошибка',
                message: 'Ошибка при прикреплении ссылки к баннеру',
                color: 'red',
            });
        }
    };

    const handleClose = () => {
        setSelectedBannerId(null);
        onClose();
    };

    const isLoading = attachLink.isPending;

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            size={400}
            title="Прикрепить ссылку к баннеру"
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Select
                    placeholder="Выберите баннер"
                    value={selectedBannerId}
                    onChange={(value) => setSelectedBannerId(value)}
                    data={banners.map(banner => ({
                        value: banner.id.toString(),
                        label: banner.title || `Баннер #${banner.id}`,
                    }))}
                    style={{ width: '100%' }}
                />
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <Button onClick={handleClose} variant="secondary">
                        Отмена
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleAttachLink}
                        disabled={!selectedBannerId || isLoading}
                        loading={isLoading}
                    >
                        Прикрепить
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

